import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import moment from "moment";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import axios from "axios";

import { SearchEventContainer } from "../styled/scheduler";
import { hexToRgb, transformEvents } from "../function/common";
import { hideLoading, showLoading } from "../../../../../store/loading";
import Loading from "../../../../../common/loading";
import ScheduleTable from "../../../../../common/scheduleTable";

const SearchEvent = ({ clickEvent, searchTxt, setSearchTxt, handleDateClick, onDate }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { mySchedSet, isDarkMode } = useSelector((state) => state?.scheduler);
  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);
  const isLoading = useSelector((state) => state?.loading?.isLoading);

  const [data, setData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  useEffect(() => {
    const search = location?.state?.search;
    if (search) {
      setSearchTxt(search);
      handleSearch();
    }
  }, []);

  const getSchedule = async () => {
    dispatch(showLoading());

    try {
      const filterOrg = (org) => {
        if (!org) return [];
        return org.filter((item) => item.check).map((item) => item.orgNo);
      };

      const url = "/api/scheduleList";
      const body = {
        mberNo: user.mberNo,
        showPersonalYn: mySchedSet.personalYn ? "Y" : "N",
        cmpnyNos: filterOrg(mySchedSet.companyYnList),
        groupNos: filterOrg(mySchedSet.groupYnList),
        completeYn: mySchedSet.completeYn || "D",
        holidayYn: "Y",
      };

      const res = await axios.post(url, body);
      const schedule = res.data;

      const { events } = await transformEvents(schedule, company);
      return events;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(hideLoading());
    }
  };

  const handleSearch = async (e) => {
    if (e) {
      e.preventDefault();
      if (!searchTxt.trim()) {
        toast.error("일정 제목을 입력해주세요.");
        return;
      }
    }

    const events = (await getSchedule()) || [];
    const matched = events.filter((event) => event.title.includes(searchTxt));
    setData(matched);
    setIsSearched(true);
    handleDateClick(onDate);
  };

  const deleteSearched = () => {
    setSearchTxt("");
    setIsSearched(false);
    setData([]);
    handleDateClick(onDate, true);

    const params = new URLSearchParams(location.search);
    if (params.has("keyword")) {
      params.delete("keyword");
      const newSearch = params.toString();
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
      window.history.replaceState(null, "", newUrl);
    }
  };

  return (
    <>
      {isLoading && <Loading />}
      <SearchEventContainer>
        <div className={isDarkMode}>
          <form onSubmit={handleSearch}>
            <div>
              <input
                type="text"
                placeholder="일정 제목을 입력해주세요"
                onChange={(e) => setSearchTxt(e.target.value)}
                value={searchTxt}
              />
              <span onClick={deleteSearched}>
                <IoMdClose />
              </span>
            </div>
            <button type="submit">검색</button>
          </form>

          {isSearched ? (
            data.length > 0 ? (
              <ScheduleTable data={data} onClickEvent={(e) => clickEvent(e, searchTxt)} />
            ) : (
              <div className="not">검색 결과가 없습니다.</div>
            )
          ) : (
            <div className="not">일정을 검색해주세요.</div>
          )}
        </div>
      </SearchEventContainer>
    </>
  );
};

export default SearchEvent;
